import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const usePublisherName = (item: useItemHandleFragment$data) => {
  switch (item.__typename) {
    case 'VaultItem':
      return item.uploadGroup?.publisher.name;
    default:
      return null;
  }
};
